import {Component, Input, OnInit} from '@angular/core';
import {ExcRestService} from 'exc-rest-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {EnumerationService} from '../../../services/enumeration.service';
import {ApplicationService} from '../../../services/application.service';

@Component({
  selector: 'app-modal-questionnaire-version',
  templateUrl: './modal-questionnaire-version.component.html',
  styles: [
  ]
})
export class ModalQuestionnaireVersionComponent extends ExcTranslation implements OnInit {

  @Input() data: any;

  dataModel: any = {
    vorgID: ''
    , qcnfID: ''
    , qverID: ''
    , isEdit: false
    , qverName: ''
    , qverDescription: ''
    , qverUPT: ''
    , qverQuestionnaireVersionStatus_enmIdent: 2
  };

  dataModelClone: any;
  isLoading = true;

  excRestServiceCore = ExcCoreModule.Services().ExcRest;

  constructor(public excRestService: ExcRestService
            , public modal: ExgModalService
            , public enumSvc: EnumerationService
            , public appSvc: ApplicationService) {
    super();
  }

  ngOnInit(): void {
    if (this.data?.isEdit) {
      this.loadData();
    } else {
      this.dataModelClone = this.appSvc.helperObj.clone(this.dataModel);
      this.isLoading = false;
    }
  }

  loadData(): void {
    const url = this.excRestService.computeUrl('QuestionnaireVersionR', {qverID: this.data.qverID});
    this.excRestService.get(url, {}).subscribe((ret: any) => {
      if (ret?.success && ret?.data?.QuestionnaireVersion) {
        this.dataModel = this.appSvc.helperObj.clone(ret.data.QuestionnaireVersion);
        this.dataModelClone = this.appSvc.helperObj.clone(this.dataModel);
      }
      this.isLoading = false;
    });
  }

  saveModalContext(): void {
    this.isLoading = true;
    if (this.data.isEdit) {
      const url = this.excRestServiceCore.computeUrl('QuestionnaireVersionU', {qverID: this.dataModel.qverID});
      this.excRestServiceCore.sput(url, {
        qverName:         this.dataModelClone.qverName,
        qverDescription:  this.dataModelClone.qverDescription,
        qverUPT:          this.dataModelClone.qverUPT
        , qverQuestionnaireVersionStatus_enmIdent:  this.dataModelClone.qverQuestionnaireVersionStatus_enmIdent
      }, ExcCoreModule.Guid.NewGuid()).subscribe((ret: any) => {
        if (ret && ret.success) {
          this.modal.action(true);
        }
        this.isLoading = false;
      });
    } else {
      const url = this.excRestServiceCore.computeUrl('QuestionnaireVersionC', {vorgID: this.data.vorgID, qcnfID: this.data.qcnfID});
      this.excRestServiceCore.spost(url, {
        qverName: this.dataModelClone.qverName,
        qverDescription: this.dataModelClone.qverDescription
        , qverQuestionnaireVersionStatus_enmIdent:  this.dataModelClone.qverQuestionnaireVersionStatus_enmIdent
      }, ExcCoreModule.Guid.NewGuid()).subscribe((ret: any) => {
        if (ret && ret.success && ret.data && ret.data[0]) {
          this.modal.action( {created: true, questVersion: ret.data[0]});
        }
        this.isLoading = false;
      });
    }
  }

  cancelModalContext(): void {
    this.modal.close();
  }

  changeStateEnum($event: any): void {
    this.dataModelClone.qverQuestionnaireVersionStatus_enmIdent = $event;
  }
}
